import React, { useState } from "react";
import { keyframes } from "@emotion/react";
import { Link, Heading, VStack, Box, HStack, Image, Text, Button, ChakraProvider, Flex } from "@chakra-ui/react";
import FullScreenSection from "./FullScreenSection";
import { LoanCalculator2 } from "./LoanCalculator2";


// Implement the UI for the LandingSection component according to the instructions.
// Use a combination of Heading and VStack components.



const LandingSection = () => {
  return (
  <FullScreenSection
    justifyContent="center"
    alignItems="center"
    isDarkBackground={false}
    backgroundColor="#F7FAFC"
    py={{ base: 24, md: 24, lg: 24 }}
   
  >
    <VStack spacing={{ base: 4, md: 8 }} top={{ base: 0, md: "25px" }} position="relative" zIndex={1} w="100%" px={{ base: 2, md: 0 }}>
      <VStack spacing={{ base: 1, md: 3, lg: 4 }} alignItems="center" border="none" textAlign="center" w="100%">
        <Heading
         fontFamily="Lora, serif"
          fontSize={{ base: "1.6rem", lg: "2.7rem" }}
          fontWeight="extrabold"
          
        >
          Get an instant loan — even with bad credit or non-traditional income.
        </Heading>
        <Text maxW="860px" color="gray.600" fontWeight="bold" fontSize={{ base: "sm", md: "md" }}>
          High approval rate. Transparent pricing. Flexible repayment options.
        </Text>
        <HStack spacing={4} pt={2} flexWrap="wrap" justifyContent="center" w="100%">
          <Button
            bg="black"
            color="white"
            borderRadius="full"
            px={7}
            _hover={{ bg: "gray.900" }}
          >
            Check eligibility
          </Button>
        </HStack>
      </VStack>
      <ChakraProvider>
        <Flex
          minH={{ base: "auto", md: "30vh" }}
          align="center"
          justify="center"
          bg="transparent"
          position="relative"
          direction={{ base: "column", lg: "row" }}
          gap={{ base: 8, lg: 0 }}
          w="100%"
        >
         
          <Flex w="100%" justify="center">
            <Box id="loan-calculator" w="100%" maxW={{ base: "100%", sm: "520px" }} px={{ base: 4, sm: 2 }} mx="auto" mt={{ base: -2, md: -4 }}>
              <LoanCalculator2 w="100%" />
            </Box>
          </Flex>
          
          {/*
          {images.length > 0 && (
            <VStack spacing={2} position="absolute" right={{ base: 0, lg: "32px" }} display={{ base: "none", lg: "flex" }}>
              {images.map((image, index) => (
                <Image
                  key={`${toCurrency}-${index}`}
                  src={image.src}
                  alt={image.alt}
                  width="350px"
                  height="230px"
                  borderRadius="xl"
                  boxShadow="lg"
                  objectFit="cover"
                />
              ))}
            </VStack>
          )} */}
        </Flex>
      </ChakraProvider>
    </VStack>
    
  </FullScreenSection>
  );
};

export default LandingSection;
